import {Component, Input, ViewChild} from '@angular/core';
import {UserReportConfig} from './user-report-config.model';
import {DatePipe} from '@angular/common';
import {ReportBuilderService} from '../../report-builder.service';
import {ReportRequest} from '../../../shared/domain/report/report-request.model';
import {DateRangeTypeLabels} from '../../../../shared/domain/date-range-type.enum';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {ReportRunnerComponent} from '../../../../shared/components/report/report-runner.component';

@Component({
  selector: 'cm-report-builder-shared-reports',
  templateUrl: './report-builder-shared-reports.component.html',
  styles: [`
    .mat-table {
        min-width: 600px;
    }
    .mat-column-options {
        flex: 0 0 100px;
        justify-content: flex-end;
        padding-right: 10px;
    }
  `]
})
export class ReportBuilderSharedReportsComponent {

  @Input() paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('runner', {static: true}) runner: ReportRunnerComponent;

  dataSource = new MatTableDataSource<UserReportConfig>();
  showReportRunner = false;
  loading = false;

  columns = [
    {key: 'name', header: 'Name', cell: (row: UserReportConfig) => `${row.name}`},
    {key: 'dateRange', header: 'Date range', cell: this.getDateRangeLabel.bind(this)},
    {
      key: 'createdOn',
      header: 'Date created',
      rawHtml: true,
      cell: (row: UserReportConfig) => `   <div class="d-flex flex-column">
        ${this.datePipe.transform(row.createdOn, 'yyyy-MM-dd')}
        <small class="d-block">${this.datePipe.transform(row.createdOn, 'hh:mm a')}</small>
      </div>`
    },
  ];
  visibleColumns;

  constructor(private service: ReportBuilderService,
              private datePipe: DatePipe) {
    this.visibleColumns = this.columns.map(c => c.key);
    this.visibleColumns.push('options')
  }

  ngOnInit(): void {
    this.loading = true;
    this.service.getSharedConfigs().subscribe(next => {
        this.dataSource.data = next;
        this.loading = false;
      },
      () => {
        this.loading = false;
      })
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  runReport(el: UserReportConfig) {

    this.runner.runReport(<ReportRequest>JSON.parse(el.config));
  }

  getDateRangeLabel(row: UserReportConfig) {
    const config: ReportRequest = <ReportRequest> JSON.parse(row.config);
    if (config && config.filters) {
      if (config.filters.dateRange) {
        return DateRangeTypeLabels[config.filters.dateRange];
      } else {
        return config.filters.dateFrom + '<br/>' + config.filters.dateTo
      }
    }
  }

}
